import React, { useCallback, useState } from 'react';
import { Tabs, TabType } from '@sovryn/ui';
import { MaxButton } from '../../2_molecules/MaxButton/MaxButton';
export const Label = ({ maxAmount, token, tabs, onTabChange, onMaxAmountClicked, hasTrove = false, }) => {
    const [index, setIndex] = useState(0);
    const onChangeIndex = useCallback((index) => {
        var _a;
        setIndex(index);
        onTabChange((_a = tabs[index]) === null || _a === void 0 ? void 0 : _a.amountType);
    }, [onTabChange, tabs]);
    return (React.createElement("div", { className: "w-full flex flex-row justify-between gap-4 items-center" },
        hasTrove ? (React.createElement(Tabs, { items: tabs, index: index, onChange: onChangeIndex, type: TabType.secondary })) : (React.createElement(React.Fragment, null, tabs[0].label)),
        React.createElement(MaxButton, { onClick: onMaxAmountClicked, value: maxAmount, token: token, dataAttribute: "convert-from-max" })));
};
